var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"20px"}},[_c('div',{staticClass:"contents"},[_c('div',{staticClass:"table"},[_c('div',{staticClass:"u-f-justify u-f-column",staticStyle:{"height":"500px"}},[_c('img',{staticStyle:{"width":"120px"},attrs:{"src":require("../../assets/image/nothing.png")}}),_c('div',{staticStyle:{"color":"#A4A4A4"}},[_vm._v("暂无数据")])])])])])
}]

export { render, staticRenderFns }